// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconToGoBadge = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M9.473 6.5c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.33.75.75.75zM12.473 6.5c.41 0 .75-.34.75-.75V2c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3.75c0 .41.33.75.75.75zM15.093 3.2l7.85.3h.03c.4 0 .73-.32.75-.72a.756.756 0 00-.72-.78l-7.85-.3h-.03c-.4 0-.73.32-.75.72-.02.41.31.76.72.78zM1.973 2h1.5c.41 0 .75-.34.75-.75S3.883.5 3.473.5h-1.5a.749.749 0 100 1.5zM23.053 5.75l-7.65-.88a.746.746 0 00-.83.66c-.05.41.25.78.66.83l7.65.88h.09c.38 0 .7-.28.74-.66a.751.751 0 00-.66-.83zM1.973 5h1.54c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.54a.749.749 0 100 1.5z"
      fill="currentColor"
    />,
    <path
      d="M19.323 9.48c-.01-.25-.08-.49-.21-.71a.752.752 0 00-.33-.39c-.28-.24-.63-.38-1-.38H7.223V1.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75V8h-2.34c-.38 0-.73.14-1.01.37a.78.78 0 00-.38.47l-.01.03c-.09.18-.14.38-.15.58l-1.53 5.72c-.11.4.13.81.53.92.07.02.13.03.19.03.33 0 .63-.22.72-.56l.67-2.49 1.46 8.51c.19 1.11 1.17 1.92 2.31 1.92h8.78c1.15 0 2.12-.81 2.32-1.92l1.45-8.49.66 2.46c.09.33.39.56.72.56.06 0 .13-.01.19-.03.4-.11.64-.52.53-.92l-1.51-5.68zM13.183 15h-5.21l-3.17-5.5 11.54.02-3.16 5.48zm2.62 6.33c-.06.39-.42.67-.83.67h-8.78c-.42 0-.77-.28-.84-.67l-1.85-11.07L6.823 16c.03.05.08.07.11.11.13.23.36.39.65.39h6c.28 0 .52-.16.65-.39.04-.04.08-.06.11-.11l3.39-5.87-1.93 11.2zm2.01-11.69v-.03.03z"
      fill="currentColor"
    />
  );
export default SvgIconToGoBadge;
